import api from "app/lib/api";
import endpoints from "static/endpoints";
import { getCurrentUserClinicName } from "utils/currentUser.util";
import { interpolate } from "utils/string";

export const getDevices = async () => {
  const account = getCurrentUserClinicName();
  const { data } = await api.get(endpoints.deviceGroups.selectors, {
    headers: { account },
  });

  return data?.devices;
};

export const getAllDevices = async () => {
  const { data } = await api.get(endpoints.devices.device);
  return data;
};

export const createDevice = async (payload) => {
  const response = await api.post(endpoints.devices.device, payload);
  return response;
};

export const updateDevice = async (id, payload) => {
  const url = interpolate(endpoints.devices.deviceById, {
    id,
  });
  const response = await api.patch(url, payload);
  return response;
};

export const deleteDevice = async (id) => {
  const url = interpolate(endpoints.devices.deviceById, {
    id,
  });
  const response = await api.delete(url);
  return response;
};

export const getAlertList = async () => {
  const { data } = await api.get(endpoints.devices.alertList);

  return data;
};
